// chakra imports
import { Box, ChakraProvider } from '@chakra-ui/react';
import Footer from 'components/Footer/Footer.js';
import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import { authRoutes } from 'routes.js';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import theme from 'theme/theme.js';

export default function Pages(props) {
	const { ...rest } = props;
	// ref for the wrapper div
	const wrapper = React.createRef();
	React.useEffect(() => {
		document.body.style.overflow = 'unset';
		// Specify how to clean up after this effect:
		return function cleanup() {};
	});

	document.documentElement.dir = 'ltr';
	return (
		<ChakraProvider theme={theme} resetCss={false} w='100%'>
			<Box w='100%'>
				<Box w='100%'>
					<Box ref={wrapper} w='100%'>
						<Switch>
							{authRoutes.map((route, key) => (
								<Route 
									path={route.layout + route.path} 
									component={route.component} 
									key={key} 
								/>
							))}
							<Redirect from='/auth' to='/auth/signin' />
						</Switch>
					</Box>
				</Box>
				<Box px='24px' mx='auto' width='1044px' maxW='100%'>
					<Footer />
				</Box>
			</Box>
		</ChakraProvider>
	);
}
